/**
 * "Design & the Widget Design Studio" — Dashboard section (ADR-0074).
 * Reconciled from apps/web design/theme, components, and widget-design-studio.
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_DESIGN_PAGE: DocPageContent = {
  slug: 'dashboard/design',
  titleKey: 'docs.dashboard.design.title',
  descriptionKey: 'docs.dashboard.design.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.design.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'components',
      textKey: 'docs.dashboard.design.components.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.design.components.body' },

    { kind: 'heading', level: 2, id: 'studio', textKey: 'docs.dashboard.design.studio.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.design.studio.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.design.studio.item.library',
        'docs.dashboard.design.studio.item.assign',
        'docs.dashboard.design.studio.item.inspector',
        'docs.dashboard.design.studio.item.detected',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'walkthrough',
      textKey: 'docs.dashboard.design.walkthrough.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.design.walkthrough.body' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.dashboard.design.walkthrough.step.open.title',
          textKey: 'docs.dashboard.design.walkthrough.step.open.text',
        },
        {
          titleKey: 'docs.dashboard.design.walkthrough.step.create.title',
          textKey: 'docs.dashboard.design.walkthrough.step.create.text',
        },
        {
          titleKey: 'docs.dashboard.design.walkthrough.step.tune.title',
          textKey: 'docs.dashboard.design.walkthrough.step.tune.text',
        },
        {
          titleKey: 'docs.dashboard.design.walkthrough.step.assign.title',
          textKey: 'docs.dashboard.design.walkthrough.step.assign.text',
        },
        {
          titleKey: 'docs.dashboard.design.walkthrough.step.activate.title',
          textKey: 'docs.dashboard.design.walkthrough.step.activate.text',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.design.next.rendering.title',
          textKey: 'docs.dashboard.design.next.rendering.text',
          to: { docSlug: 'rendering' },
        },
        {
          titleKey: 'docs.dashboard.design.next.monitoring.title',
          textKey: 'docs.dashboard.design.next.monitoring.text',
          to: { docSlug: 'dashboard/monitoring' },
        },
      ],
    },
  ],
};
